import { ORDER_BY } from "~/common/constants";

export const PATIENTS_TABLE_COLUMN_IDS = {
  name: "name",
  lastInteraction: "lastInteraction",
  primaryProvider: "primaryProvider",
  state: "state",
  lastUpdated: "lastUpdated",
} as const;

export type PatientsTableColumnId =
  (typeof PATIENTS_TABLE_COLUMN_IDS)[keyof typeof PATIENTS_TABLE_COLUMN_IDS];

export const COLUMN_ID_TO_ORDER_BY: Record<
  PatientsTableColumnId,
  (typeof ORDER_BY)[keyof typeof ORDER_BY]
> = {
  [PATIENTS_TABLE_COLUMN_IDS.name]: ORDER_BY.lastName,
  [PATIENTS_TABLE_COLUMN_IDS.lastInteraction]: ORDER_BY.feed,
  [PATIENTS_TABLE_COLUMN_IDS.primaryProvider]: ORDER_BY.provider,
  [PATIENTS_TABLE_COLUMN_IDS.state]: ORDER_BY.state,
  [PATIENTS_TABLE_COLUMN_IDS.lastUpdated]: ORDER_BY.completedDate,
};

const orderByToColumnId = Object.entries(COLUMN_ID_TO_ORDER_BY).map(
  ([columnId, orderBy]) => [orderBy, columnId] as const,
);

export const ORDER_BY_TO_COLUMN_ID = Object.fromEntries(
  orderByToColumnId,
) as Record<string, PatientsTableColumnId>;

export const getOrderByFromColumnId = (
  columnId: string,
): (typeof ORDER_BY)[keyof typeof ORDER_BY] | undefined =>
  COLUMN_ID_TO_ORDER_BY[columnId as PatientsTableColumnId];

export const getColumnIdFromOrderBy = (
  orderBy: string,
): PatientsTableColumnId | undefined => ORDER_BY_TO_COLUMN_ID[orderBy];
